<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="25" height="25" fill="white" fill-opacity="0.01" />
            <path
                d="M8.89562 1.63112C9.43976 1.64174 10.7308 1.77697 11.7021 2.74956C12.48 3.53055 12.7203 4.52072 12.7904 5.16338C13.9075 2.91735 14.7364 1.849 14.7364 1.849C14.9035 1.64927 15.2464 1.57192 15.4986 1.67793L16.7822 2.42683C17.0344 2.53239 17.0582 2.74214 16.8364 2.89274C16.8364 2.89274 15.8607 3.89188 15.1061 4.67036C14.2163 5.5876 13.5119 6.54352 13.0667 7.21144C18.3979 5.09941 22.5 7.90938 22.5 12.7022C22.5 17.666 18.5524 25.2829 12.4985 22.9293C6.75048 25.2051 2.5 17.6656 2.5 12.7022C2.5 7.95033 7.06346 5.2177 11.8644 7.16867C11.9965 6.86086 12.1268 6.56694 12.2548 6.28675L12.2366 6.28816L12.0966 6.28802C11.5514 6.27745 10.2584 6.14245 9.28932 5.17084C8.31962 4.19825 8.18554 2.90122 8.1753 2.35438L8.17523 2.21391C8.17671 2.1367 8.1803 2.0938 8.1803 2.0938C8.19936 1.86148 8.40431 1.6555 8.63636 1.63596C8.63636 1.63596 8.67903 1.63239 8.75585 1.63096L8.89562 1.63112Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgDSEALegislativeAction',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>